import React from 'react';
import { ChevronRight } from 'lucide-react';
import './Breadcrumbs.css';

/**
 * Breadcrumb navigation component.
 *
 * @param {Object} props
 * @param {Array<{label: string, onClick?: function, icon?: React.Component}>} props.items
 *   Array of breadcrumb items. Last item is rendered as active (non-clickable).
 * @param {string} [props.className] - Additional CSS class
 */
const Breadcrumbs = ({ items = [], className = '' }) => {
  if (!items || items.length <= 1) return null;

  return (
    <nav className={`breadcrumbs ${className}`} aria-label="Breadcrumb">
      <ol className="breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const Icon = item.icon;

          return (
            <li key={index} className="breadcrumbs-item">
              {index > 0 && (
                <ChevronRight size={14} className="breadcrumbs-separator" />
              )}
              {isLast ? (
                <span className="breadcrumbs-current" aria-current="page">
                  {Icon && <Icon size={14} />}
                  {item.label}
                </span>
              ) : (
                <button
                  className="breadcrumbs-link"
                  onClick={item.onClick}
                  type="button"
                >
                  {Icon && <Icon size={14} />}
                  {item.label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
